module.exports = __webpack_public_path__ + "static/media/Hair_1_brown.857ccb54.svg";